import * as yup from 'yup';

export const absenceSchema = (t) =>
  yup.object({
    absence_minmax_contract_fte: yup
      .number()
      .required()
      .min(0, t('absenceProcedure.positiveMessage')),
    absence_zero_hours_contract_fte: yup
      .number()
      .required()
      .min(0, t('absenceProcedure.positiveMessage')),
    absence_hours_contract_fte: yup
      .number()
      .required()
      .min(0, t('absenceProcedure.positiveMessage')),
    absence_dcc_5_not_halve: yup.boolean().required(),
    absence_dcc_7_ill: yup.boolean().required(),
    absence_dcc_18_ill: yup.boolean().required()
  });
